/* tslint:disable */
import {
  ChartOfAccount,
  TenantPayments
} from '../index';

declare var Object: any;
export interface PaymentEntriesInterface {
  "payment_channel": string;
  "payment_reference": string;
  "amount_paid": number;
  "transaction_date": Date;
  "bank_account_id": number;
  "tenant_payment_id": number;
  "lease_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  chartOfAccount?: ChartOfAccount;
  tenantPayments?: TenantPayments;
}

export class PaymentEntries implements PaymentEntriesInterface {
  "payment_channel": string;
  "payment_reference": string;
  "amount_paid": number;
  "transaction_date": Date;
  "bank_account_id": number;
  "tenant_payment_id": number;
  "lease_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  chartOfAccount: ChartOfAccount;
  tenantPayments: TenantPayments;
  constructor(data?: PaymentEntriesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PaymentEntries`.
   */
  public static getModelName() {
    return "PaymentEntries";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PaymentEntries for dynamic purposes.
  **/
  public static factory(data: PaymentEntriesInterface): PaymentEntries{
    return new PaymentEntries(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PaymentEntries',
      plural: 'PaymentEntries',
      path: 'PaymentEntries',
      idName: 'id',
      properties: {
        "payment_channel": {
          name: 'payment_channel',
          type: 'string'
        },
        "payment_reference": {
          name: 'payment_reference',
          type: 'string'
        },
        "amount_paid": {
          name: 'amount_paid',
          type: 'number'
        },
        "transaction_date": {
          name: 'transaction_date',
          type: 'Date'
        },
        "bank_account_id": {
          name: 'bank_account_id',
          type: 'number'
        },
        "tenant_payment_id": {
          name: 'tenant_payment_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'bank_account_id',
          keyTo: 'id'
        },
        tenantPayments: {
          name: 'tenantPayments',
          type: 'TenantPayments',
          model: 'TenantPayments',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_payment_id',
          keyTo: 'id'
        },
      }
    }
  }
}
